import { render } from "./JurnalRecord.vue?vue&type=template&id=24822e7c&scoped=true"
import script from "./JurnalRecord.vue?vue&type=script&lang=js"
export * from "./JurnalRecord.vue?vue&type=script&lang=js"

import "./JurnalRecord.vue?vue&type=style&index=0&id=24822e7c&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24822e7c"]])

export default __exports__